export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      objid: '',
      tableName: '',
      inputData: '',
      disabled: false,
      parseNum: {
        start: 0,
        end: 0,
        min: 0,
        max: 100,
        step: 1
      },
    }
  },
  mounted() {
    const { tableName, itemId } = this.$route.params
    this.tableName = tableName
    this.objid = itemId == 'New' ? -1 : itemId
    this.objid != -1 && (this.inputData = this.options.valuedata)
    this.getData()
  },
  watch: {
    inputData(v) {
      const data = v || [];
      this.$emit('change', data);
    },
  },
  computed: {
    placeholder() {
      switch (this.tableName) {
        case 'PS_C_PRO':
          return '请输入SPU编码'
        case 'PS_C_BRAND_MATCH':
          return '请输入解析位数'
        default:
          return '';
      }
    }
  },
  methods: {
    getData() {
      switch (this.tableName) {
        case 'PS_C_PRO':
          this.proEcodeInfo()
          break;
        case 'PS_C_BRAND_MATCH':
          this.parseNumInfo()
          break;
        default:
          break;
      }
    },
    // SPU编码
    async proEcodeInfo() {
      if (this.objid == -1) {
        const formData = new FormData();
        formData.append('param', this.tableName);
        formData.append('type', '商品款号');
        const { data: { code, data, message }} = await this.service.commodityCenter.getCodeAndParam(formData);
        if (code == 0) {
          if (data.ps_c_pro_code_rule == '1') {
            this.inputData = data.code
            return
          }
        } else {
          $utils.msgTips(this, 'error', message, 0);
        }
      } else {
        this.disabled = true
      }
    },
    // 解析位数
    parseNumInfo() {
      const pattern = /第(\d+)至(\d+)位/g
      this.options.valuedata.replace(pattern, (_,$1,$2) => {
        this.parseNum = {
          ...this.parseNum,
          start: Number($1),
          end: Number($2)
        }
      })
    },
    onBlurForInputNumber() {
      const { start, end } = this.parseNum
      this.$nextTick(() => {
        end < start && (this.parseNum.end = start + 1)
        this.inputData = `第${start}至${this.parseNum.end}位`
      })
    }
  }
};
